<template>
	<label>
		<em class="lt_text">Sales Group</em>
		<span class="int_type_no_border mgr_5"><CodeSelect className="tbl_select" :codes="display_codes" :displayDescription="true" v-model="code" @input="updateValue"/></span>
	</label>
</template>

<script>
import CodeSelect from '@/components/common/CodeSelect';
import { selectAllSalesGroupList } from '@/api/basicinfo/salesgroup';
import { objectToUrlParam } from '@/api/util';

export default {
	inject: { state_report_context: { default: null } },
	name: 'SalesGroup',
	props: {
		value: String,
		allSelect: Boolean,
	},
	computed: {
		display_codes() {
			const context = this.state_report_context;
			return context && context.restriction_only && context.state_report_filters ? context.state_report_filters.restrictionOnlySalesGroupList || [] : this.codes;
		},
	},
	watch: {
		value: {
			handler() {
				if (this.codes && this.codes.length > 0) this.setValue();
			},
		},
	},
	data: function() {
		return {
			codes: [],
			code: '',
			active_yn: 'Y',
		};
	},
	methods: {
		async selectData() {
			const param = {
				allSelect: this.allSelect,
				active_yn: this.active_yn,
			};
			const { data } = await selectAllSalesGroupList(objectToUrlParam(param));
			this.codes = data.codeList;
			this.setValue();
		},
		setValue() {
			this.code = this.value || '';
		},
		updateValue() {
			this.$emit('input', this.code);
		},
		reset() {
			this.code = '';
		},
	},
	components: {
		CodeSelect,
	},
	mounted() {
		this.selectData();
	},
};
</script>

<style scoped></style>
